import script from "./CreateFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateFolder.vue?vue&type=script&setup=true&lang=js"

import "./CreateFolder.vue?vue&type=style&index=0&id=85f5ad74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85f5ad74"]])

export default __exports__